export const BASE_PATH = "/parola-del-giorno";

export const DASHBOARD_URL = `${process.env.REACT_APP_MYZ_URL}/dashboard`;

export const S3_IMAGE_FOLDER = `${process.env.REACT_APP_S3_URL}/wotd/images`;
